import "./ModelListLayoutController.css";

import { ToggleButtonGroup } from "@mui/material";
import WindowIcon from "@mui/icons-material/Window";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CustomToggleButton from "@common-components/CustomToggleButton/CustomToggleButton";

const ModelsDisplayLayoutController = ({
  modelListLayoutStyle,
  handleSwitchModelListLayoutStyle,
}) => {
  return (
    <ToggleButtonGroup
      value={modelListLayoutStyle}
      exclusive
      onChange={handleSwitchModelListLayoutStyle}
      aria-label="model-list-layout-style"
      color="primary"
      className="ModelListLayoutController__buttongroup"
    >
      {/* <CustomToggleButton
        value="grid"
        disabled={modelListLayoutStyle === "grid"}
        id="ModelListLayoutController__button"
      >
        <WindowIcon />
      </CustomToggleButton> */}
      <CustomToggleButton
        value="list"
        disabled={modelListLayoutStyle === "list"}
        id="ModelListLayoutController__button"
      >
        <FormatListBulletedIcon />
      </CustomToggleButton>
    </ToggleButtonGroup>
  );
};

export default ModelsDisplayLayoutController;
